import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea } from "rbx";
import { BooleanInput, SystemCodeSelect, ColorPicker } from "../inputs";

const BookingCodeForm = ({ inputs, onChange }) => (
  <div style={{ minHeight: 300, minWidth: 500 }}>
    <Field kind="group">
      <Control expanded>
        <Label>Booking Code</Label>
        <Input
          required
          autocomplete="new"
          name="BookingCode"
          type="text"
          value={inputs.BookingCode}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Multiple Days</Label>
        <BooleanInput
          name="MultipleDays"
          value={inputs.MultipleDays}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Active</Label>
        <BooleanInput name="Active" value={inputs.Active} onChange={onChange} />
      </Control>
    </Field>
    <Field kind="group">
      <Control>
        <ColorPicker name="Color" value={inputs.Color} onChange={onChange} />
      </Control>
      <Control expanded>
        <SystemCodeSelect
          icon="book-open"
          label="BOOKCATG"
          lookup={{ Category: "BookingCodes", Code: "BookCatg" }}
          name="CodeCatgRecIdRef"
          value={inputs.CodeCatgRecIdRef}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field>
      <Control>
        <Label>Description</Label>
        <Textarea
          required
          name="Description"
          rows="2"
          value={inputs.Description}
          onChange={onChange}
        />
      </Control>
    </Field>
  </div>
);

BookingCodeForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
BookingCodeForm.defaultProps = {
  inputs: {}
};
export default BookingCodeForm;
